export default {"src":"/_next/static/image/public/images/flags/flag_244.ad19c2bbfe6085d134dee492beb038fd.svg","height":16,"width":25};